import style from "./style.scss";
import slugify from "slugify";
import Link from "../../components/link";
import { mergeClasses } from "../helpers";

const getTextFromChildren = (children) => {
  return (Array.isArray(children) ? children : [children])
    .map((child) => {
      if (typeof child === "string") {
        return child;
      }
      if (child && typeof child === "object" && child.props?.children) {
        return getTextFromChildren(child.props.children);
      }
      return "";
    })
    .join(" ");
};

/**
 * @typedef {"p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6"} HeadingTag
 *
 * @typedef {object} SlugHeadingProps
 * @property {HeadingTag} [tag]
 * @property {boolean} [hideAnchor]
 * @property {import("preact").JSX.HTMLAttributes["class"]} [class]
 * @property {import("preact").ComponentChildren} children
 *
 * @param {SlugHeadingProps} props
 */
const SlugHeading = ({
  tag: Tag = "p", // Assign the tag name dynamically
  hideAnchor = false,
  class: className = null,
  children,
  ...props
}) => {
  const slug = slugify(getTextFromChildren(children), {
    lower: true,
  });

  return (
    <Tag
      class={mergeClasses([style.slugHeading, className])}
      id={slug}
      {...props}
    >
      {children}
      {!hideAnchor ? (
        <Link class={style.link} href={`#${slug}`}>
          <span class={style.icon} />
        </Link>
      ) : null}
    </Tag>
  );
};

export default SlugHeading;
